export class Certificate {
    constructor(id, name) {
        this.id = id;
        this.name = name;
    }
    get selectedTitleId() {
        return `selected-cert-${this.id}`;
    }
}
